(function() { module.exports = this["wp"]["editor"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","editor"]}
// module id = 2
// module chunks = 0